
import Vue from 'vue'
import { URL_SCHEDULER } from '@/constants/urls.js'
import { SCHEDULER, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const actions = {
  async [SCHEDULER.ACTIONS.SEND_ERRORS_NOTIFICATION] ({ dispatch, commit }, model) {
    if (!model.date) {
      throw new Vue.errorsTypes.ValidationError(this.$t('Не задана начальная дата сбора логов.'))
    }
    model.date = Vue.moment(model.date).utc().format()
    model = {
      url: `${Vue.getAdminHost()}${URL_SCHEDULER}/notification/logErrors/${model.date}`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [SCHEDULER.ACTIONS.SEND_AUTHORIZATION_DOCUMENT_EXPIRATION_DATE_NOTIFICATION] ({ dispatch, commit }, model) {
    if (!model.interval) {
      throw new Vue.errorsTypes.ValidationError(this.$t('Не задан интервал истечения срока загрузки уведомления об аффинаже.'))
    }
    model = {
      url: `${Vue.getIdentityHost()}${URL_SCHEDULER}/notification/authorizationDocumentsExpiration?days=${model.interval}`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [SCHEDULER.ACTIONS.SEND_ACTIVITY_STATISTICS_NOTIFICATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getAdminHost()}${URL_SCHEDULER}/notification/activityStatistics`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  }
}

export default {
  namespaced: true,
  actions
}
